module.exports = __webpack_public_path__ + "static/media/fr.0c817ea9.csv";